// extracted by mini-css-extract-plugin
export default {"action":"GeneralPane_action__B+y47","actionButton":"GeneralPane_actionButton__QZx1A","wrapper":"GeneralPane_wrapper__MEQME"};